import { render, staticRenderFns } from "./WarningsOverviewModal.vue?vue&type=template&id=5142ce5c"
import script from "./WarningsOverviewModal.vue?vue&type=script&lang=js"
export * from "./WarningsOverviewModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports